<script setup lang="ts"></script>

<template>
   <div class="communication-index">
      <RouterView></RouterView>
   </div>
</template>

<style lang="scss" scoped>
.communication-index {
   width: 100%;
   height: 100%;
}
</style>
